var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4H16V16H3V4ZM7 15V13H4V15H7ZM7 12V10H4V12H7ZM7 9V7H4V9H7ZM11 15V13H8V15H11ZM11 12V10H8V12H11ZM11 9V7H8V9H11ZM15 15V13H12V15H15ZM15 12V10H12V12H15ZM15 9V7H12V9H15ZM15 6V5H4V6H15ZM1 3V5H2V6H1V8H2V9H1V11H2V12H0V0H13V3H1ZM1 1V2H12V1H1Z",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.5b5ac7a2abbc78e99ee3c8eee3016ce9.svg";
export { ForwardRef as ReactComponent };